import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=a3bfa060&scoped=true"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"
import style0 from "./ViewPost.vue?vue&type=style&index=0&id=a3bfa060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bfa060",
  null
  
)

export default component.exports